import NotifyDialogsService from '@Containers/Dialogs/NotifyDialogsService';

export const ZERO_RESULTS_MODAL_CONFIG = {
  title: 'Reaxys found no results',
  text: 'The selected substance has no preparation available in Reaxys. Please select another one and try again.',
  confirmText: 'Ok',
};

export const SIMILARITY_NOT_POSSIBLE_MODAL_CONFIG = {
  text: "The selected structure doesn't have preparations in Reaxys and cannot be used in similarity searches. Please consider using a different structure.",
  confirmText: 'Got it',
};

export function showDialogZeroResults() {
  return NotifyDialogsService.openModalWindow({
    ...ZERO_RESULTS_MODAL_CONFIG,
    type: 'info',
    backdrop: 'static',
    trackingOptions: {
      component: 'Synthesis planner',
    },
  });
}

export function showSimilarityNotPossible() {
  return NotifyDialogsService.openModalWindow({
    ...SIMILARITY_NOT_POSSIBLE_MODAL_CONFIG,
    type: 'error',
    trackingOptions: {
      component: 'Synthesis planner',
    },
  });
}
